@if (orderService.order$ | async; as order) {
  <div [class.hidden]="order.is_dropshipping" id="cart-widget">
    @if (order?.order_items?.length && hasOrdersPermission) {
      <div class="relative">
        <patron-button
          (onClick)="panel.toggle($event)"
          shape="circle"
          iconName="bi-cart"
          variant="outline">
        </patron-button>
        <div class="absolute" style="top: -12px; right: -10px">
          <patron-badge color="primary" size="sm">{{ order?.order_items?.length }}</patron-badge>
        </div>
      </div>
    }
    <p-popover z-index="1034" #panel>
      <div class="flex flex-column gap-3 w-25rem">
        <div>
          <ul class="list-none p-0 m-0 flex flex-column gap-4">
            @for (orderItem of order.order_items; track orderItem) {
              <li class="flex align-items-center justify-content-between gap-2">
                <div class="flex align-items-center gap-2">
                  <img
                    [src]="orderItem.item?.photos?.[0]?.url ?? '/assets/imagem-nao-disponivel.png'"
                    style="width: 50px" />
                  <span class="font-medium" [patron-tooltip]="orderItem.item?.description ?? ''">
                    {{ orderItem.item?.description ?? '' | truncate: [60] }}
                  </span>
                </div>
                <div class="text-right">
                  <div class="text-sm text-color-secondary">Qtd: {{ orderItem.quantity }}</div>
                  @if (showPrices$ | async) {
                    <div class="font-bold">
                      {{ orderItem.final_value | currency: 'BRL' }}
                    </div>
                  }
                </div>
              </li>
            }
            <li class="flex justify-content-between gap-2">
              <patron-button
                size="sm"
                variant="outline"
                iconName="bi-cart"
                [routerLink]="
                  order.is_dropshipping
                    ? '/v3ndor/pedidos/novo-dropshipping'
                    : '/v3ndor/pedidos/novo'
                "
                (onClick)="panel.hide()">
                Continuar pedido
              </patron-button>
              @if (showPrices$ | async) {
                <span class="flex align-items-center gap-2">
                  Total: <span class="font-bold">{{ order.total_value | currency: 'BRL' }}</span>
                </span>
              }
            </li>
          </ul>
        </div>
      </div>
    </p-popover>
  </div>
}
